let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("71ZfD")).then(() => parcelRequire('2T0sT'));